import {IntercomDevice} from 'src/apis/autoGenerate/types/intercomDevice';

export function getDeviceBuildingOrAmenityName(device: IntercomDevice): string | undefined {
  if (device.building?.name) {
    return device.building.name;
  }
  const amenities = device.apartment?.amenities;
  if (!amenities?.length) {
    return undefined;
  }
  if (device.amenityId) {
    const byId = amenities.find(a => a.id === device.amenityId);
    if (byId?.name) {
      return byId.name;
    }
  }
  const deviceId = device.id;
  if (deviceId) {
    for (const amenity of amenities) {
      if (amenity.intercomDevices?.some(d => d.id === deviceId) && amenity.name) {
        return amenity.name;
      }
    }
  }
  return undefined;
}
